import { fileUrl } from "../utils/utils";

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
const FILES_BASE_URL = process.env.REACT_APP_UPLOAD_FILES_BACKEND_URL;

const POST = "POST";

export const mockFetchAPI=({ok=true, data=[]})=>{
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			if(ok){
				resolve({
					ok: true,
					data,
				});
			} else {
				console.log('Error al error del mockFetchAPI');
				reject({
					ok: false,
					message: 'Error al obtener los datos',
				});
			}
		}, 2000);
	});
};
const fetchAPI = (method, url, request) => {
    return fetch(`${url}`, {
        method,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
    });
};
const fetchAPIFiles = (method, url, formData) => {
    return fetch(`${url}`, {
        method,
        body: formData,
    });
};

export const obtenerOrdenesDePago = (request) =>
    fetchAPI(POST, `${BASE_URL}/FetchComprobantesOrdenDePago`, {
        ...request,
    });

export const obtenerOrdenDePagoPorNroSiniestro = (request) =>
    fetchAPI(POST, `${BASE_URL}/FetchDataFromDBNroSiniestro`, {
        ...request,
    });

export const registrarAccesoProveedor = (request) =>
    fetchAPI(POST, `${BASE_URL}/LogIn`, {
        ...request,
    });

export const obtenerArchivo = (request) =>
    fetchAPI(POST, `${BASE_URL}/FetchFile`, {
        ...request,
    });

export const subirArchivo = (request) =>
    fetchAPIFiles(POST, `${FILES_BASE_URL}/files/UploadFile`, request)
        .then((response) => response.json())
        .then((data) => {
            const { data: url } = data;

            // if (!data.ok) throw Error("Error al subir el archivo!");

            console.log("Exito al cargar archivo!");

            return { url: fileUrl(url) };
        });

export const obtenerArchivosPorTags = (request) => {
    return fetchAPI(POST, `${FILES_BASE_URL}/files/FilterByTags`, [...request])
        .then((response) => response.json())
        .then((data) => {
            const { data: files } = data;
            const [filesArr] = files;

            return filesArr;
        });
};
